import { render, staticRenderFns } from "./emissionReduce.vue?vue&type=template&id=b71c3cfa"
import script from "./emissionReduce.vue?vue&type=script&lang=js"
export * from "./emissionReduce.vue?vue&type=script&lang=js"
import style0 from "./emissionReduce.vue?vue&type=style&index=0&id=b71c3cfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports